













































































































































































































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';


//@ts-ignore
import poas from '@/mixins/axios/poas'
//@ts-ignore
import TablePPoa from '@/components/tables/tablev1'
//@ts-ignore
import POAHeader from '@/components/headersSelect/POA'
//@ts-ignore
import poa_lineas_accion from '@/mixins/axios/poa_lineas_accion'
//@ts-ignore
import poa_actividades_lineas_accion from '@/mixins/axios/poa_actividades_lineas_accion'
//@ts-ignore
import PmdHeader from '@/components/headersSelect/pmd'
//@ts-ignore
import poa_series from '@/mixins/axios/poa_series'
//@ts-ignore
import indicador_administradores from '@/mixins/axios/indicador_administradores'
//@ts-ignore
import dependencias from '@/mixins/axios/general_secretarias'
//@ts-ignore
import poa_techo_departamentos from '@/mixins/axios/poa_techo_departamentos'

//@ts-ignore
import departamentos from '@/mixins/axios/general_departamentos'
//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'


@Component({
  components: {
   /*
    Vuetable,
    VuetablePagination,*/
    POAHeader,
    TablePPoa
  },
  data() {
    return {
        //idmunicipio,nombre, fecha_alta, 
            // tipo, total_empleados, nombre_titular, correo, abreviacion,
  
        columnasd:[
             
            
            /*{
                tag:'edit',
                data:'edit',
                active:false
            },*/
            {
                tag:'id',
                data:'id',
                active:true
            },
            
             
             {
                tag:'nombre',
                data:'nombre',
                active:true
            },
              {
                tag:'secretaria',
                data:'secretaria',
                active:true
            },
             {
                tag:'departamento',
                data:'departamento',
                active:true
            },
            {
                tag:'imprimirpoa',
                data:'imprimirpoa',
                active:false
            },
             {
                tag:'select1',
                data:'select',
                active:false
            },
        
             {
                tag:'delete',
                data:'delete',
                active:false
            },
            
              {
                tag:'edit',
                data:'edit',
                active:false
            },
            
           
        ],

    poa_lineas_accion:false,
    poa_actividades_lineas_accion:false,

    nombreserie:'',
    nombresecretaria:'',
    nombrdepartamento:'',
        id:null as any,
        poa_series_id:0,
        secretarias_id:0,
        departamentos_id:0,

        indicador_fin_id:0,
        
        fecha_inicial:'' as any,
        fecha_final:'' as any,
        nombre:'' as any,

        proposito:'' as any,
        fin:'' as any,
        descripcion:'' as any,
        
        
        poa_series:[] as any,
        departamentos:[] as any,
        dependencias:[] as any,
indicador_administradores:[]as any,
iddepartamento:0,
idserie:0,
idsecretaria:0,

presupuestodepartamento:0,
ejercido:0,
planeado:0,

         
              poadata:[] as any,
      
    }
  },
     mixins: [poas,poa_series, dependencias,poa_techo_departamentos,
     departamentos,indicador_administradores],
     validations: {
     poa_series_id: {
      required,
    },
      secretarias_id: {
      required,
    },
     departamentos_id: {
      required,
    },

  indicador_fin_id: {
      required,
    },
      nombre: {
      required,
    },
           fecha_inicial: {
      required,
    },
          fecha_final: {
      required,
    },
      descripcion: {
      required,
    },
           proposito: {
      required,
    },
    
   
    fin: {
      required,
    },
   
     

   
  },
  methods:{

       clearstate(){
this.$store.commit('SETPOA',null);
 this.$router.push('/mun/poa/poas')
        },


      onChangeDepartamento(event){
//console.log(event.target.value)
//this.TechoDisponible(event.target.value);
},

         onChange(event){
//console.log(event.target.value)
this.getDataDepartamentos(event.target.value);
},


async TechoDisponible(id){

this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
id:id
};

let data= await this.GET_TECHODISPONIBLE(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.departamentos=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });


},
async getDataDepartamentos(id) {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
iddependencia:id,
idmunicipio:this.$store.state.user.usuario.id_municipio

};

let data= await this.GET_GENERAL_DEPARTAMENTOS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.departamentos=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
      async getDataSecretarias() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio
};

let data= await this.GET_SECRETARIAS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.dependencias=response;
this.getDataDepartamentos(response[0].id);
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
        onChangeS(event){
//console.log(event.target.value)
this.getDataSerie(event.target.value);

},
      
       async getDataSerie(id) {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio

};

let data= await this.GET_POA_SERIES(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.poa_series=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},

 onChangeAdmi(event){
//console.log(event.target.value)
this.getDataAdministra(event.target.value);

},
      
       async getDataAdministra(id) {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data3={
idmunicipio:this.$store.state.user.usuario.id_municipio

};

let data= await this.GET_ADMINISTRADORES(data3).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.indicador_administradores=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},



      async eliminar(row){
         
this.$root.$emit('loading', true);
let data= await this.ELIMINAR_POAS(row).then(response => {

                    if (response != null) {

 this.poadata=this.poadata.filter(item => item.id !== row.id);
 
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar eliminar paquete, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                });
      },
       select(row){

//alert('pmd seleccionado');
 //this.$store.state.pmd_sel=row;
 this.$store.commit('SETPOA',row);
           //this.secretaria_sel=row;
//this.departamentos=true;
 //this.$store.commit('SETSECRETARIA',row);
   this.$router.push('/mun/poa/poas/lineas')
//this.getDataDepartamentos();

      
     },
     setimprimir(row){

//alert('pmd seleccionado');
 //this.$store.state.pmd_sel=row;
 this.$store.commit('SETPOA',row);
           //this.secretaria_sel=row;
//this.departamentos=true;
 //this.$store.commit('SETSECRETARIA',row);
   this.$router.push('/mun/poa/poas/imprimirpoa')
//this.getDataDepartamentos();

     },
     confirm(row){

let th=this;
Notiflix.Confirm.Show('Alerta de confirmacion','Desea eliminar este elemento?','Aceptar','Cancelar',function(){ 
    
    th.eliminar(row);
    },function(){ 
      
        
    });

              


      
     },
      limpiar(){
        this.id=null;
        this.poa_series_id=0;
        this.departamentos_id=0;
        this.secretarias_id=0;

        this.indicador_fin_id=0;

        this.nombre=null;  
        this.fecha_inicial=null;
        this.fecha_final=null;


        this.proposito=null;  
        this.descripcion=null;
        this.fin=null;

        
    
           
      },
      addRow(){
          this.limpiar();
 $('#ac_modal_poa').modal('show')
      },
seteditar(row){


    this.id=row.id;
    this.poa_series_id=row.poa_series_id;
    this.departamentos_id=row.departamentos_id;
    this.secretarias_id=row.secretarias_id;
    this.indicador_fin_id=row.indicador_fin_id;
    this.nombre=row.nombre;
    this.fecha_inicial=row.fecha_inicial;
    this.fecha_final=row.fecha_final;
    this.proposito=row.proposito;
    this.descripcion=row.descripcion;
    this.fin=row.fin;

            
          
 $('#ac_modal_poa').modal('show')
    

},
     async crear(dat){
let data= await this.CREAR_POAS2(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)

  this.poadata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar POA, refresque la pagina");

                    }    $("#ac_modal_poa").modal("hide");
 this.$root.$emit('loading', false);
                    //loading.close();
                });

      },
     async editar(dat){


let data= await this.EDITAR_POAS(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)
this.$root.$emit("success", "POA modificada correctamente.");
  this.poadata=this.poadata.filter(item => item.id !== dat.id);
 this.poadata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar crear POA, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });


      }
     ,
     async GuardarData(){



console.log('id:'+this.id)

let dat={
        id:this.id,
        poa_series_id:this.poa_series_id,
        departamentos_id:this.departamentos_id,
        secretarias_id:this.secretarias_id,
        indicador_fin_id:this.indicador_fin_id,
        nombre:this.nombre,
        fecha_inicial:this.fecha_inicial,
        fecha_final:this.fecha_final,
        proposito:this.proposito,
        descripcion:this.descripcion,
        fin:this.fin,

            //idmunicipio:this.$store.state.user.usuario.id_municipio,

}
console.log(dat)
 this.$root.$emit('loading', true);
 if(this.id==null){
     this.crear(dat);
 }else{
       this.editar(dat);
 }

      },
      
async getData() {
  


console.log('----',this.poa_series.filter(item => item.id == this.idserie))
let eldependencia=(this.dependencias.filter(item => item.id == this.idsecretaria).length>0)?'Dependencia: '+this.dependencias.filter(item => item.id == this.idsecretaria)[0]['nombre']:'';
let eldepartamento=(this.departamentos.filter(item => item.id == this.iddepartamento).length>0)?'Departamento: '+this.departamentos.filter(item => item.id == this.iddepartamento)[0]['departamento']:''
let elpoaserie=(this.poa_series.filter(item => item.id == this.idserie).length>0)?'Serie: '+this.poa_series.filter(item => item.id == this.idserie)[0]['ano']:'';


this.nombresecretaria=eldependencia;
this.nombreserie=elpoaserie;
this.nombrdepartamento=eldepartamento;

 this.$root.$emit('loading', true);
 console.log('loaddding');


let data5={
secretarias_id:this.idsecretaria,
departamentos_id:this.iddepartamento,
poa_series_id:this.idserie,
};

let data= await this.GET_POAS(data5).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.poadata=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });

                let dataPresupuesto= await this.GET_PRESUPUESTO(data5).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
console.log(response)
this.ejercido=response.avancefinanciero[0].ejercido;
this.planeado=response.avancefinanciero[0].planeado;
this.presupuestodepartamento=response.presupuestado[0].monto;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });






},



 async getDataLinea() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding');

let data6={
poas_id:this.poa_sel.id,


};

let data= await this.GET_POA_LINEAS_ACCION(data6).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.poa_lineas_accion=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
}

  },
 
 created(){
 //this.clearstate()
 },
  mounted(){
     console.log(this.$route,'-------')
if(this.$route.query.hasOwnProperty('poaid')){
this.getData();
this.$store.commit('SETPOASEL',null);
}
    
      //
      this.getDataSerie();
      this.getDataAdministra();
         this.getDataSecretarias();





      //alert('10')
  }
})
export default class Home extends Vue {}

